import classNames from 'classnames';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './message-content.module.css';

type TextAlignment = 'center' | 'left' | 'right';

type TextProperties = {
  label: ReactNode;
  textAlign?: TextAlignment;
};

const MessageContent = ({ label, textAlign = 'center' }: TextProperties) => {
  const { t } = useTranslation();

  return (
    <span
      className={classNames(styles['message-content'], {
        [styles['message-content--center'] ?? '']: textAlign === 'center',
        [styles['message-content--left'] ?? '']: textAlign === 'left',
        [styles['message-content--right'] ?? '']: textAlign === 'right',
      })}
    >
      {typeof label === 'string' ? t(label) : label}
    </span>
  );
};

export default MessageContent;
